import { render } from "./StudentPopup.vue?vue&type=template&id=0c34dfae&scoped=true"
import script from "./StudentPopup.vue?vue&type=script&lang=js"
export * from "./StudentPopup.vue?vue&type=script&lang=js"

import "./StudentPopup.vue?vue&type=style&index=0&id=0c34dfae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c34dfae"]])

export default __exports__